<body class="ftu text-center">
  <div class="container ftu d-flex h-100">
    <main role="main" class="row justify-content-center align-self-center">
      <h3 class="cover-heading text-dark">Преобразователь потоков (flow) P1, P1_1, P1_2, P1_3 к виду диаграммы классов UML (с наследованием)</h3>
      <div class="lead pt-3">
        <input type="file" name="file"  class="inputfile" id="inputFile" onchange="readFile()" accept="text/plain"/>
        <label class="btn btn-lg btn-outline-dark"  for="inputFile">Преобразовать</label>
        <img class="spoiler-title mx-2" src="https://lh3.googleusercontent.com/proxy/CU4h2Ps-vkY3jcA07eT3ivuD61cTawED3Klk0ajbwLwEUjCzrcjizuMw8fA61Q2LCLWYq2RfP5I52KyHR0dHtKS8cla1a3v0ZK1FGqPXwBiOMpLl5hwqTTVuSyvKG1S8" width="30px" height="30px">
        <div class="spoiler-body bg-white px-2 py-2 my-2 rounded">
          <h5><b>Инструкция по применению</b></h5>
          <p class="text-left">
            Чтобы воспользоваться функционалом данного сайта необходимо нажать на кнопку "Преобразовать" и выбрать файл с расширением .txt,в котором должна находиться полное описание IDEF0 в виде xml :
          </p>
          <ol>
            <li class="text-left"><em>В шапке указываются все общие потоки используемые в IDEF0.</em></li>
            <li class="text-left"><em>В каждом блоке F указываются потоки входящие в данный блок, а так же у потоков данных указываются откуда ( если имеется предшественник) эти данные, если нет то null.</em></li>
          </ol>
          <p class="text-left">
            Пример файла можете скачать,<a class="text-info" href="https://vk.com/away.php?to=http%3A%2F%2Fdrive.google.com%2Fu%2F0%2Fuc%3Fid%3D19CcauWGV8CcoyMqSxPkRgQbGNTi8HamM%26export%3Ddownload&cc_key=">нажав сюда</a>.
          </p>
        </div>
      </div>
      <div class="container">
        <canvas id="myCanvas" width="480" height="320"  onload="draw();"></canvas>
      </div>
    </main>
  </div>
</body>
